import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['fileName', 'fileXlsx', 'preview', 'form', 'corporation', 'corporationError', 'formButton', 'scheduledMonth']

  onChangeFileUserXlsx(event) {
    this.fileNameTarget.innerText = event.target.files[0].name;

    this.onChangeCorporationSelect(event);
    const formData = new FormData(this.formTarget);

    Rails.ajax({
      url: '/admin/health_check_lists/preview',
      type: 'POST',
      dataType: 'html',
      data: formData,
      success: (response)=> {
        this.previewTarget.innerHTML = response.body.innerHTML;
        if(document.querySelector(".error") == undefined) {
          this.formButtonTarget.classList.remove("is-hidden");
        }else{
          this.formButtonTarget.classList.add("is-hidden");
        }
      },
      error: (response)=> {
          this.previewTarget.innerHTML = "<div class='notification mb-2 is-warning'>エラーが発生しました。アップロードしたファイルを読み込めません。</div>";
      }
    });
  }

  onClickFileUserXlsx(event) {
    event.stopPropagation()

    this.fileXlsxTarget.value = null
  }

  onChangeCorporationSelect(event){
    if (this.corporationTarget.value == ""){
      this.corporationErrorTarget.classList.remove("is-hidden");
    }else{
      this.corporationErrorTarget.classList.add("is-hidden");
    }
  }

  onSubmit(event){
    this.onChangeCorporationSelect(event);
    if(this.corporationTarget.value != ""){
      this.formTarget.submit();
    }
  }

  addScheduledMonth(event){
    const el = event.currentTarget;
    const select = this.scheduledMonthTarget;
    el.before(select.cloneNode(true));
  }

}
